import { tv, VariantProps } from "@utils/tw"
import { PropsWithChildren } from "react"

type AlertProps = VariantProps<typeof createStyles> &
  PropsWithChildren<{
    className?: string
  }>

export function Alert({ error, ...props }: AlertProps) {
  return <div {...props} className={createStyles({ error })} />
}

const createStyles = tv({
  base: "border border-current text-black pt-[0.4em] pb-[0.2em] px-[0.5em] type-body-xs",
  variants: {
    error: {
      true: "text-red",
    },
  },
})
